// import { transformer } from "zod";

export const Mask = {
  formatCurrency: (value: number) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
    return formatter.format(value);
  },
  formatCurrencyFromCents: (cents: number) => {
    if (cents === 0) {
      return Mask.formatCurrency(0);
    }
    const valueInReais = cents / 100.0;
    return Mask.formatCurrency(valueInReais);
  },
  maskString: (value: string, pattern: string) => {
    if (!value || !pattern) {
      return "";
    }
    let i = 0;
    let masked = "";
    const v = value.toString();
    for (let j = 0; j < pattern.length; j++) {
      if (i >= v.length) break;
      if (pattern[j] === "#") {
        masked += v[i++];
      } else {
        masked += pattern[j];
      }
    }
    return masked;
  },
  dateTime: (value: string) => {
    if (!value) {
      return "";
    }
    return new Date(value).toLocaleString("pt-BR");
  },

  maskCpfOrCnpj: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    if (v.length <= 11) {
      return Mask.maskString(v, "###.###.###-##");
    }
    return Mask.maskString(v, "##.###.###/####");
  },

  maskCpf: (value: string) => {
    const cleanedText = value.replace(/\D/g, "");

    let maskedText = "";
    for (let i = 0; i < cleanedText.length; i++) {
      if (i === 3 || i === 6) {
        maskedText += ".";
      }
      if (i === 9) {
        maskedText += "-";
      }
      if (i === 11) {
        break;
      }
      maskedText += cleanedText[i];
    }

    return maskedText;
  },
  maskPhone: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    
    if (v.length === 13 && v.startsWith("55")) {
      const phoneWithoutCountryCode = v.substring(2);
      return Mask.maskString(phoneWithoutCountryCode, "(##) #####-####");
    }
    
    return Mask.maskString(v, "(##) #####-####");
  },
  maskBirthday: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    return Mask.maskString(v, "##/##/####");
  },
  date: (value: string) => {
    if (!value) {
      return "";
    }
    return new Date(value).toLocaleDateString("pt-BR");
  },
  tranformMaskBirthdayInUs: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    return `${v.substring(4, 8)}-${v.substring(2, 4)}-${v.substring(0, 2)}`;
  },
  transformMaskBirthdayInBr: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    return `${v.substring(6, 8)}/${v.substring(4, 6)}/${v.substring(0, 4)}`;
  },
  clearMask: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    return v;
  },
  maskCEP: (value: string) => {
    if (!value) {
      return "";
    }
    const v = value.replace(/\D/g, "");
    return Mask.maskString(v, "#####-###");
  },
  transformCurrencyInFloat: (value: string): string => {
    let removeCurrency: string = value.replace("R$", "").trim();
    // Remove TODOS os pontos (separadores de milhar)
    removeCurrency = removeCurrency.replace(/\./g, "");
    // Substitui vírgula (decimal) por ponto
    removeCurrency = removeCurrency.replace(",", ".");

    return removeCurrency;
  },
  /**
   * Retorna a data local no formato YYYY-MM-DD
   * Evita problemas de timezone ao usar toISOString()
   */
  getLocalDate: (date?: Date): string => {
    const d = date || new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
};
type patternProps = { replacement?: RegExp | string };

export const formatValue = ({
  pattern,
  replacement = "_",
  value,
}: patternProps & { value: string; pattern: string }) => {
  let newValue = "";
  let index = 0;

  for (let i = 0; i < pattern.length && index < value.length; i++)
    newValue +=
      pattern[i].match(replacement) !== null ? value[index++] : pattern[i];

  return newValue.replace(replacement, "");
};


export const formatNumber = (value: number) => {
  return value < 10 ? `0${value}` : `${value}`;
}